import React, { useState } from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function TabsRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  // Tabs könnten perspektivisch als Array gespeichert werden.
  // Für schnelles Prototyping und robuste Inspector Controls speichern wir sie als kommaseparierte Strings.
  const rawLabels = content.tabLabels || 'Tab 1, Tab 2, Tab 3';
  const rawContents = content.tabContents || 'Inhalt von Tab 1\n\nInhalt von Tab 2\n\nInhalt von Tab 3';
  
  const labels = rawLabels.split(',').map(s => s.trim()).filter(Boolean);
  const contents = rawContents.split('\n\n').map(s => s.trim()); // Doppelte Zeilenumbrüche trennen Inhalte
  
  const [activeTab, setActiveTab] = useState(0);

  const activeColor = content.activeColor || '#00A9E0';
  const inactiveColor = content.inactiveColor || '#64748b';

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      {/* Tab Header (Knöpfe) */}
      <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.1)', overflowX: 'auto', gap: '8px' }}>
        {labels.map((label, idx) => {
          const isActive = idx === activeTab;
          return (
            <button
              key={idx}
              onClick={() => setActiveTab(idx)}
              style={{
                padding: '12px 24px',
                background: isActive ? 'rgba(255,255,255,0.05)' : 'transparent',
                border: 'none',
                borderBottom: isActive ? `2px solid ${activeColor}` : '2px solid transparent',
                color: isActive ? activeColor : inactiveColor,
                cursor: 'pointer',
                fontWeight: isActive ? '600' : '400',
                transition: 'all 0.2s',
                whiteSpace: 'nowrap'
              }}
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div style={{ padding: '24px 0', color: '#cbd5e1', lineHeight: '1.6' }}>
        {contents[activeTab] || 'Kein Inhalt für diesen Tab definiert.'}
      </div>
    </div>
  );
}

registry.register('Tabs', {
  label: 'Reiter (Tabs)',
  icon: '📑', 
  category: 'layout', // Oder 'advanced'
  component: TabsRender,
  
  defaultProps: {
    content: {
      tabLabels: 'O2 Mobile M, O2 Mobile L, O2 Mobile XL',
      tabContents: '25 GB+ Datenvolumen\nAllnet-Flat\n5G bis 300 Mbit/s\n\n70 GB+ Datenvolumen\nAllnet-Flat\n5G bis 300 Mbit/s\n\n280 GB+ Datenvolumen\nAllnet-Flat\n5G bis 300 Mbit/s',
      activeColor: '#00A9E0',
      inactiveColor: '#64748b'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Registerkarten',
          fields: [
            { name: 'content.tabLabels', label: 'Tab Titel (kommasepariert)', type: 'text' },
            { name: 'content.tabContents', label: 'Tab Inhalte (getrennt durch 2x Enter)', type: 'textarea' }
          ]
        },
        {
          title: 'Styling',
          fields: [
            { name: 'content.activeColor', label: 'Farbe (Aktiv)', type: 'color' },
            { name: 'content.inactiveColor', label: 'Farbe (Inaktiv)', type: 'color' }
          ]
        }
      ]
    }
  ]
});
